interface UploadPreviewProps {
  files: File[]
  onRemove: (index: number) => void
}

export function UploadPreview({ files, onRemove }: UploadPreviewProps) {
  if (files.length === 0) return null

  return (
    <div className="flex gap-2 px-3 py-2 border-b border-[rgb(var(--np-border))] bg-[rgb(var(--np-raised)/0.3)] overflow-x-auto">
      {files.map((file, i) => (
        <div
          key={`${file.name}-${i}`}
          className="relative shrink-0 bg-[rgb(var(--np-surface))] border border-[rgb(var(--np-border))] rounded-md p-2 flex items-center gap-2 max-w-48"
        >
          {file.type.startsWith('image/') ? (
            <img
              src={URL.createObjectURL(file)}
              alt={file.name}
              className="w-10 h-10 rounded object-cover"
            />
          ) : (
            <svg className="w-10 h-10 text-[rgb(var(--np-tx-muted))] p-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
            </svg>
          )}
          <div className="min-w-0 flex-1">
            <p className="text-xs font-medium text-[rgb(var(--np-tx-primary))] truncate">{file.name}</p>
            <p className="text-[10px] font-data text-[rgb(var(--np-tx-muted))]">
              {(file.size / 1024).toFixed(0)} KB
            </p>
          </div>
          <button
            onClick={() => onRemove(i)}
            className="absolute -top-1.5 -right-1.5 w-5 h-5 bg-[rgb(var(--np-status-critical))] text-white rounded-full flex items-center justify-center text-xs"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  )
}
